/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'basket-plus': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2m3-5l-.04.29L22 13.8a6.005 6.005 0 00-9 5.2c0 .7.13 1.37.35 2H5.5c-.78 0-1.46-.45-1.79-1.1L1.1 10.44 1 10c0-.55.45-1 1-1h4.58l4.6-6.57a.997.997 0 011.65.01L17.42 9H22c.55 0 1 .45 1 1m-9 5c0-1.1-.89-2-2-2s-2 .9-2 2 .9 2 2 2 2-.89 2-2m1-6l-3-4.26L9 9h6z"/>'
  }
})
